import type {SVGProps} from 'react'
const WishlistOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="none"
    width="1em"
    height="1em"
    overflow="visible"
    style={{
      display: 'block',
    }}
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Outline"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.5C0 0.671573 0.671573 0 1.5 0H8.5C9.32843 0 10 0.671572 10 1.5V15.9343L5 12.6009L0 15.9343V1.5ZM1.5 1C1.22386 1 1 1.22386 1 1.5V14.0657L5 11.3991L9 14.0657V1.5C9 1.22386 8.77614 1 8.5 1H1.5Z"
      fill="var(--fill-0, #2D2E2C)"
    />
  </svg>
)
export {WishlistOutlineIcon}
